import React from "react";
import { useHistory } from "react-router-dom";
import { PROPOSAL_BOOKING } from "../../constants/routes";
import P from "../../shared/typography/P";
import Button from "../../shared/ui/Button";

const PaymentSection = ({ isApproved }) => {
    const history = useHistory();
    return (
        <div className="hidden sm:block">
            <div className=" bg-gray-200 p-1 text-center rounded-xl mb-3 ">
                <P className="lg:text-lg xl:text-lg">Payment Terms</P>
            </div>
            <ul className="ml-3 mb-4">
                <P className="flex flex-col gap-1 md:text-sm xl:text-sm font-light">
                    <li className="list-disc">
                        25 % Advance with confirmed Purchase Order
                    </li>
                    <li className="list-disc">70 % before material dispatch</li>
                    <li className="list-disc">
                        05 % at the time of Final commissioning.
                    </li>
                </P>
            </ul>
            {isApproved && (
                <Button
                    onClick={() => history.push(PROPOSAL_BOOKING)}
                    className="bg-primary w-full md:text-sm xl:text-sm !rounded-2xl"
                >
                    PAY NOW
                </Button>
            )}
        </div>
    );
};

export default PaymentSection;
